import NotifyIsImporting from './notify_is_importing.vue'
import { createCmpEngine } from '@/utils'

export const openNotifyIsImporting = createCmpEngine(NotifyIsImporting)
